var Model = require("../../../types/Model.js");
var log = require("../../../../utils/BluetoothLog").logState;

var CONNECTION_TIMEOUT = 15 * 1000;
var READING_TIMEOUT = 30 * 1000;

var DEVICES = [
	"deviceA&DWeight",
	"deviceIHWeight"
];

var DEVICE_MAP = {
	"a&dweight": "deviceA&DWeight",
	"ihweight": "deviceIHWeight"
};

var MODEL_MAP = {
	"deviceA&DWeight": "A&D_UC",
	"deviceIHWeight": "51-102"
};

module.exports = new Model({
	name: "deviceweight",
	listeners,
	triggers,
	init,
	uninit,

	info,
	clean,
	begin,
	cleanState,
	readDevice,
	handleDisconnect,
	handleDeviceFailed,
	handleConnectionFailed
});

function triggers() {
	return {
		"showinfo": info,
		"workflow": workflow,
		"begin": begin,
		"clean": clean,
		"pair": pair
	};
}

function listeners(){
	return DEVICES.reduce((acc, device) => {
		acc[`${device}:done`] = handleDone;
		acc[`${device}:battery`] = handleBattery;
		acc[`${device}:hasRead`] = handleHasRead;
		return acc;
	}, {
		"bluetooth:scanned": handleScanned,
		"bluetooth:connected": handleDeviceConnected,
		"bluetooth:failed": handleDeviceFailed,
		"bluetooth:disconnected": handleDeviceDisconnected,
		"owndevices:updated": handleDevicesUpdate,
		"activemanagegroup:updated": handleManageGroupUpdated
	});
}

function init(){
	this._isWorkflow = false;
	this._isPairing = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._hasConnected = false;
	this._hasFinishedReading = false;
	this._hasDisconnected = false;
	this._hasRead = false;
	this._ignoreEvents = true;
	this._hasFailed = false;
	this._shouldDisconnect = false;

	this._managed = null;
	this._deviceType = null;
	this._deviceMac = null;

	this._retryConnect = 0;

	this._readingTimeout = null;
	this._connectionTimeout = null;
}

function uninit(){
	this._isWorkflow = false;
	this._isPairing = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._hasConnected = false;
	this._hasFinishedReading = false;
	this._hasDisconnected = false;
	this._hasRead = false;
	this._ignoreEvents = true;
	this._hasFailed = false;
	this._shouldDisconnect = false;

	this._managed = null;
	this._deviceType = null;
	this._deviceMac = null;

	this._retryConnect = 0;

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	this._readingTimeout = null;
	this._connectionTimeout = null;
}

function pair(){
	this._isPairing = true;
	// log(this, "WeightPairStart", this);
	this.begin();
}

function workflow(){
	this._isWorkflow = true;
	// log(this, "WeightWorkflowStart", this);
	this.info();
}

function info(data){
	var macs = this._assignedMacs || {};

	var first = Object.keys(macs)[0];
	var firstDevice = macs[first] || {};
	var device = firstDevice.model || "a&dweight";
	if(data && data.who) this._managed = data.who;

	var model = DEVICE_MAP[device];
	this._deviceType = model;

	// log(this, "WeightInfo", this);
	this.emit(`${model}:trigger:info`);
	this.emit("bluetooth:trigger:initialize");
}

function begin(){
	var isPairing = this._isPairing;
	var feedbackMessage = {
		title: "myhealthdevice.reading_from_device",
		items: {
			connect: {
				type: "load",
				progress: 0,
				message: "myhealthdevice.connecting",
				cancelPair: isPairing ? "myhealthdevice:trigger:clean" : null
			}
		}
	};

	if(!isPairing)
		feedbackMessage.items.reading = {
			type: "progress",
			progress: 0,
			message: "myhealthdevice.reading",
			cancelTrigger: "myhealthdevice:trigger:clean"
		};

	this.emit("screenlocker:trigger:unlock");
	this.emit("feedbackmodal:trigger:show", feedbackMessage);

	const action = isPairing ? "pair with" : "read from";
	this.emit("usermetrics:trigger:track", `begin ${action} device forweight`, {
		"device type": this._deviceType || "a&dweight",
	});

	this.readDevice();
}

function readDevice(){
	var isPairing = this._isPairing;
	this._ignoreEvents = false;
	this._isScanning = true;

	this._connectionTimeout = setTimeout(handleConnectionFailed.bind(this), CONNECTION_TIMEOUT);

	this.emit("bluetooth:trigger:scan");
	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.scanning",
			cancelPair: isPairing ? "myhealthdevice:trigger:clean" : null
		}
	});
}

function handleScanned(scanned){
	var isScanning = this._isScanning;
	var isPairing = this._isPairing;

	if(this._ignoreEvents) return;

	var macs = this._assignedMacs;
	var macKeys = Object.keys(macs);
	var isMacs = macKeys.length;
	var macExists = macKeys.indexOf(scanned.id) !== -1;

	var model = MODEL_MAP[this._deviceType];

	if(!isScanning) return;
	if(!(scanned && scanned.name && scanned.name.indexOf(model) !== -1)) return;
	if(isMacs && !macExists) return;

	var found = scanned.id;
	this._isScanning = false;
	this._isConnecting = true;
	this._deviceMac = found;

	// log(this, "WeightScanned", this);
	this.emit("bluetooth:trigger:scan:stop");
	this.emit("bluetooth:trigger:connect", {
		mac: found,
		model: model
	});

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.connecting",
			cancelPair: isPairing ? "myhealthdevice:trigger:clean" : null
		}
	});

}

function handleDeviceConnected(){
	var isPairing = this._isPairing;
	var isConnecting = this._isConnecting;
	if(!isConnecting || this._ignoreEvents) return;

	this._isConnecting = false;
	this._hasConnected = true;

	clearTimeout(this._connectionTimeout);
	this._readingTimeout = setTimeout(handleDeviceFailed.bind(this), READING_TIMEOUT);

	if(!isPairing) this.emit("screenlocker:trigger:lock");
	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: isPairing ? "myhealthdevice.paired" : "myhealthdevice.connected",
			cancelPair: isPairing ? "myhealthdevice:trigger:clean" : null
		}
	});

	// log(this, "WeightConnected", this);
	if(isPairing) return setTimeout(handleDisconnect.bind(this), 5000);
	setTimeout(startRead.bind(this), 1000);
}

function startRead(){
	var device = this._deviceType;
	this.emit(`${device}:trigger:ready`, {
		mac: this._deviceMac
	});
}

function handleDone(reading){
	var isWorkflow = this._isWorkflow;
	var managed = this._managed;
	var manageGroup = this._manageGroup;
	if(!reading) return;

	this._hasFinishedReading = true;
	clearTimeout(this._readingTimeout);
	// log(this, "WeightDone", this);

	var processReading = null;
	if(isWorkflow) processReading = handleWorkflow.bind(this);
	else if(managed){
		reading.managerId = managed;
		if(manageGroup)
			reading.group = manageGroup;
		processReading = this.api.manage.weight.add;
	} else processReading = this.api.device.weight.add;

	return processReading(reading).then(() => {
		setTimeout(handleDisconnect.bind(this, 3000));
	}).catch(handleDeviceFailed.bind(this));
}

function handleDisconnect(){
	var hasConnected = this._hasConnected;
	var hasDisconnected = this._hasDisconnected;
	var deviceMac = this._deviceMac;

	// log(this, "WeightDisconnect", this);
	if(hasConnected && !hasDisconnected){
		this._shouldDisconnect = true;
		this._hasConnected = false;
		this.emit("bluetooth:trigger:disconnect", {
			mac: deviceMac
		});
	} else if (hasConnected && hasDisconnected)
		this.clean();
}

function handleDeviceDisconnected(){
	var hasFinishedReading = this._hasFinishedReading;
	var hasRead = this._hasRead;
	var deviceType = this._deviceType;
	var isPairing = this._isPairing;

	if(this._ignoreEvents) return;

	this._hasDisconnected = true;
	if(deviceType)
		this.emit(`${deviceType}:trigger:disconnect`);

	if(hasRead) return;

	// log(this, "WeightDisconnected", this);
	if(hasFinishedReading || isPairing) this.clean();
	else this.handleDeviceFailed();
}

function handleHasRead(){
	this._hasRead = true;
}

function clean(){
	this.emit("feedbackmodal:trigger:hide");
	if(this._isScanning) this.emit("bluetooth:trigger:scan:stop");
	if(this._deviceType) this.emit(`${this._deviceType}:trigger:clean`);
	if(!this._hasFailed)
		log(this, "WeightSuccess", this);
	else
		log(this, "WeightFailed", this);
	// log(this, "WeightClean", this);
	this.cleanState();
}

function cleanState(){
	this.emit("screenlocker:trigger:lock");
	this._isWorkflow = false;
	this._isPairing = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._hasConnected = false;
	this._hasFinishedReading = false;
	this._hasRead = false;
	this._hasDisconnected = false;
	this._ignoreEvents = true;
	this._hasFailed = false;
	this._shouldDisconnect = false;

	this._deviceMac = null;

	this._retryConnect = 0;

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	this._readingTimeout = null;
	this._connectionTimeout = null;
	// log(this, "WeightCleaned", this);
}

function handleConnectionFailed(){
	var retried = ++this._retryConnect;
	clearTimeout(this._connectionTimeout);

	// log(this, "WeightConnectionFailed", this);
	if(retried <= 2) this.readDevice();
	else this.handleDeviceFailed();
}

function handleDeviceFailed(){
	var deviceType = this._deviceType;
	var isScanning = this._isScanning;
	var isConnecting = this._isConnecting;
	var hasConnected = this._hasConnected;
	var retryConnect = this._retryConnect;
	var isWorkflow = this._isWorkflow;

	if(this._ignoreEvents) return;

	if((isScanning || isConnecting) && retryConnect <= 2)
		return this.handleConnectionFailed();

	if(!(isScanning || isConnecting || hasConnected)) return;

	// log(this, "WeightFailed", this);
	this._hasFailed = true;
	if(deviceType) this.emit(`${deviceType}:trigger:failed`);
	else this.emit("deviceA&DWeight:trigger:failed");

	if(!this._hasDisconnected)
		this.handleDisconnect();

	this.clean();
	this._isWorkflow = isWorkflow;
}

function handleBattery(reading){
	var deviceMac = this._deviceMac;

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: "myhealthdevice.batterylevel",
			messageArgs: {
				battery: reading
			}
		}
	});

	var assignedMacs = this._assignedMacs;
	var keys = Object.keys(assignedMacs);

	if(!keys.length) return;
	var device = assignedMacs[deviceMac];
	if(!device) return;

	// log(this, "WeightBattery", this);
	return this.api.devices.battery(device._id, reading);
}

function handleWorkflow(reading){
	// eslint-disable-next-line compat/compat
	return new Promise((resolve) => {
		var legible = legibleReading(reading);
		this.dispatch("reading", {
			legible: legible,
			value: reading
		});
		resolve();
	});
}

function handleDevicesUpdate(data){
	var list = data.list;

	var newMacs = list.reduce((acc, device) => {
		if(device.device_type === "weight")
			acc[device.mac] = device;
		return acc;
	}, {});

	this._assignedMacs = newMacs;
}

function legibleReading(readings) {
	return `${readings.weight} ${readings.units}`;
}

function handleManageGroupUpdated(group){
	this._manageGroup = group;
}